import ImagePreviewModal from "./image_preview_modal.js";
import { createElement } from "./dom_utils.js";

function createImageAttachmentDisplay(attachment) {
  const container = createElement("div", {
    className: "widget_attachment_icon",
    style: "cursor: pointer;",
  });

  const img = createElement("img", {
    src: attachment.url,
    alt: attachment.file_name,
    style:
      "width: 100% !important; height: 100% !important; object-fit: cover !important;",
  });

  container.appendChild(img);

  container.addEventListener("click", (e) => {
    e.stopPropagation();
    const modal = new ImagePreviewModal();
    modal.open(attachment.url);
  });

  return container;
}

export default createImageAttachmentDisplay;

